/* src/app/shared/modal-dialogs/update-progress/update-progress.component.css */
.updateProgressSuccess {
  height: 100px;
  width: 100px;
}
/*# sourceMappingURL=update-progress.component.css.map */
